<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-tit">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Many thanks to Byron Strom, descendant of Silas Soule’s brother, William Soule, and keeper of the Soule flame. Byron’s generosity of spirit is inspiring. Thanks also to Vicki Casteel, who shared her many historical documents and thoughtful insights with me about the characters involved in this drama. I owe Vicki particular thanks for tracking down the grave of Joseph Cramer. I also owe many thanks to Barbara Gay, Dana Younger (a distant cousin of Samuel Tappan), Sharon Crowder, Garry O’Hara at Riverside Cemetery, Molly McGarry, Criss Clinton (aka Jim-Criss), Richard Turner, Lynn Turner and John Turner.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?287beba5